import { render } from "./GroupNotifications.vue?vue&type=template&id=c3a69faa&scoped=true"
import script from "./GroupNotifications.vue?vue&type=script&lang=js"
export * from "./GroupNotifications.vue?vue&type=script&lang=js"

import "./GroupNotifications.vue?vue&type=style&index=0&id=c3a69faa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3a69faa"]])

export default __exports__